@if (showFooter && !isViewOnly()) {
  <div class="text-end form-label-footer">
    {{ 'form.required.sign'|translate }} {{ 'form.required.label'|translate }}
  </div>
}
